module.exports = __webpack_public_path__ + "img/perfection.6f45616.webp";